import { RectTablePropertiesPanel } from "./RectTablePropertiesPanel";
import { SeatsPropertiesPanel } from "./SeatsPropertiesPanel";
import { RowPropertiesPanel } from "./RowPropertiesPanel";
import { IconPropertiesPanel } from "./IconPropertiesPanel";
import { ShapePropertiesPanel } from "./ShapePropertiesPanel";
import { ZonePropertiesPanel } from "./ZonePropertiesPanel";
import { TextPropertiesPanel } from "./TextPropertiesPanel";
import { RoundTablePropertiesPanel } from "./RoundTablePropertiesPanel";

export const OBJECT_COMPONENT_DEFINITION = {
  rectTable: RectTablePropertiesPanel,
  roundTable: RoundTablePropertiesPanel,
  seat: SeatsPropertiesPanel,
  row: RowPropertiesPanel,
  svg: IconPropertiesPanel,
  shape: ShapePropertiesPanel,
  polygonZone: ZonePropertiesPanel,
  text: TextPropertiesPanel
};